import { XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { TruncatedText } from '@/components/atoms/TruncatedText/TruncatedText';
import { Badge } from '@/components/ui/badge';

type Props = { tags: string[]; onDelete?: (tag: string) => void };

/**
 * Renders a wrapping row of outline badges for a tag list. When `onDelete` is
 * provided each chip gets a remove button (editable Tags section); without it
 * the chips are read-only (replay Conversation panel).
 */
export const TagChips = ({ tags, onDelete }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex max-w-full min-w-0 flex-wrap content-start items-start gap-1 self-stretch">
      {tags.map((tag) => (
        <Badge
          key={tag}
          type="outline"
          size="xs"
          rounded={false}
          // [&_button_svg]:size-4 — the xs variant would force the icon to 14px.
          className="max-w-full min-w-0 shrink border-border bg-background font-semibold [&_button_svg]:size-4"
          // trailingIcon, not a child: children land inside the badge's block
          // `truncate` span, which drops the button below center.
          trailingIcon={
            onDelete && (
              <button
                type="button"
                onClick={() => onDelete(tag)}
                aria-label={t('common.remove_value', { 0: tag })}
                className="rounded-sm text-muted-foreground hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
              >
                <XIcon size={16} />
              </button>
            )
          }
        >
          <TruncatedText text={tag} className="block w-full" size="large" />
        </Badge>
      ))}
    </div>
  );
};
